import React from 'react';
import {
    Box, CircularProgress, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Chip, Typography
} from '@material-ui/core';
import { WhatsAppTransactionType } from 'api/whatsapp/types';
import { IApiState } from 'store/types';
import { apiStatus } from 'shared/constants/AppEnum';
import HeadingCard from 'components/Card/HeadingCard';

interface TransactionTableProps {
    transactions: WhatsAppTransactionType[];
    api: IApiState;
}

const getAmountColor = (amount: number) => (amount >= 0 ? '#4caf50' : '#f44336');

const TransactionTable: React.FC<TransactionTableProps> = ({ transactions, api }) => {
    return (
        <HeadingCard title="Transaction History" cardContent={false} hasheaderBackground={false}>
            {api.status === apiStatus.LOADING ? (
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress />
                </Box>
            ) : transactions.length === 0 ? (
                <Box textAlign="center" my={4}>
                    <Typography color="textSecondary">No transactions found</Typography>
                </Box>
            ) : (
                <TableContainer component={Paper} elevation={0}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Type</TableCell>
                                <TableCell>Credit Type</TableCell>
                                <TableCell align="right">Amount</TableCell>
                                <TableCell align="right">Balance After</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactions.map((txn) => (
                                <TableRow key={txn.id}>
                                    <TableCell>
                                        <Chip
                                            label={txn.transaction_type_display}
                                            size="small"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell>{txn.credit_type_display}</TableCell>
                                    <TableCell
                                        align="right"
                                        style={{ color: getAmountColor(txn.amount), fontWeight: 600 }}
                                    >
                                        {txn.amount > 0 ? `+${txn.amount}` : txn.amount}
                                    </TableCell>
                                    <TableCell align="right">{txn.balance_after}</TableCell>
                                    <TableCell>{txn.description}</TableCell>
                                    <TableCell>
                                        {new Date(txn.created_at).toLocaleDateString()}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </HeadingCard>
    );
};

export default TransactionTable;
